import React from 'react';

/**
 * Data table. Renders a native table with every prop passed through; width,
 * borders and text size come from `className`. A single component so that
 * table-wide styling can be changed in one place.
 */
export const Table = React.forwardRef<HTMLTableElement, React.TableHTMLAttributes<HTMLTableElement>>((props, ref) => (
  <table ref={ref} {...props} />
));

Table.displayName = 'Table';
